<div class="reason-container d-flex justify-content-center align-items-center bg-neutral-n1">
  <span class="fs-2 ps-0_5 mx-0_5" [ngClass]="getIcon('messageState')"></span>
  <span class="divider">/</span>
  <span class="fs-2 mx-0_5" [ngClass]="getIcon('testStatus')"></span>
  <span class="divider">/</span>
  <span class="fs-4 pe-0_5 mx-0_5" [ngClass]="getExpectedRepetitionsClass()">{{getExpectedRepetitions()}}</span>
</div>
